'use client';

import { Menu } from '@shared/lib/shopify/types';
import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

const FooterMenuItem = ({ item }: { item: Menu }) => {
  const pathname = usePathname();
  const [active, setActive] = useState(pathname === item.path);

  useEffect(() => {
    setActive(pathname === item.path);
  }, [pathname, item.path]);

  return (
    <li className="flex flex-row items-center justify-center">
      <Link
        href={item.path}
        className={clsx(
          'block py-1 text-sm uppercase underline-offset-4 hover:text-black hover:underline md:inline-block md:text-sm',
          {
            'text-black underline': active,
          }
        )}
      >
        {item.title}
      </Link>
    </li>
  );
};

export default function FooterMenu({ menu }: { menu: Menu[] }) {
  if (!menu.length) return null;

  return (
    <ul className="sm:grid-col-3 grid grid-cols-2 gap-x-4 md:grid-cols-4 md:gap-y-4 xl:grid-cols-6 xl:gap-y-6">
      {menu.map((item: Menu) => {
        return <FooterMenuItem key={item.title} item={item} />;
      })}
    </ul>
  );
}
